module.exports = __webpack_public_path__ + "img/2C.2ebae580.svg";